import { Challan } from './../Model/Challan';
import { LHContract } from './../Model/LHContract';
import { VchalanDetail } from './../Model/VchalanDetail';
import { Vchalan } from './../Model/Vchalan';
import { environment } from '../../environments/environment';
import { Injectable, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class VehicleChalanService {

    constructor(private _httpClient: HttpClient) { }


    AddVehicleChalan(input: Challan): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        let body = JSON.stringify(input);
        return this._httpClient.post(environment.WebserviceUrl + "vchalan", body, httpOptions);
    }

    UpdateVehicleChalan(input: Challan): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        let body = JSON.stringify(input);
        return this._httpClient.put(environment.WebserviceUrl + "vchalan", body, httpOptions);
    }

    AddVehicleChalanDetail(input: VchalanDetail[]): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        let body = JSON.stringify(input);
        return this._httpClient.post(environment.WebserviceUrl + "vchalandetail", body, httpOptions);
    }

    UpdateVehicleChalanDetail(input: VchalanDetail[]): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        let body = JSON.stringify(input);
        return this._httpClient.put(environment.WebserviceUrl + "vchalandetail", body, httpOptions);
    }

    GETChallanList(intype: number, iLocId: number, cnno: string, userid: number): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.get(environment.WebserviceUrl + "vchalan?intype=" + intype + "&iLocId=" + iLocId + "&cnno=" + cnno + "&userid=" + userid, httpOptions);
    }

    GETChallanDetail(input: string): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.get(environment.WebserviceUrl + "vchalan/" + input, httpOptions);
    }

    GETChallanGRList(input: string): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.get(environment.WebserviceUrl + "vchalandetail/" + input, httpOptions);
    }

    GETChallanListForDDL(intype: number, vno: string, iLocId: number): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.get(environment.WebserviceUrl + "VehicleChallan?intype=" + intype + '&vno=' + vno + '&iLocId=' + iLocId, httpOptions);
    }

    DeleteChallan(CHNO: string, iUserId: number): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.delete(environment.WebserviceUrl + "vchalan?CHNO=" + CHNO + "&iUserId=" + iUserId, httpOptions);
    }

    //=====================================Truck arrival=====================================================
    AddTruckArrivalReport(input: Vchalan[]): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        let body = JSON.stringify(input);
        return this._httpClient.post(environment.WebserviceUrl + "TruckArrival", body, httpOptions);
    }

    UpdateTruckArrivalReport(input: Vchalan[]): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        let body = JSON.stringify(input);
        return this._httpClient.put(environment.WebserviceUrl + "TruckArrival", body, httpOptions);
    }

    UpdatehortQantity(input: any[]): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        let body = JSON.stringify(input);
        return this._httpClient.put(environment.WebserviceUrl + "grbookingHelper", body, httpOptions);
    }

    GETTruckArrivalList(input: number): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.get(environment.WebserviceUrl + "TruckArrival?locId=" + input, httpOptions);
    }

    //=====================================Lorry Hire Contract=====================================================
    AddLHContract(input: LHContract): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        let body = JSON.stringify(input);
        return this._httpClient.post(environment.WebserviceUrl + "Lorryhirecontract", body, httpOptions);
    }

    UpdateLHContract(input: LHContract): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        let body = JSON.stringify(input);
        return this._httpClient.put(environment.WebserviceUrl + "Lorryhirecontract", body, httpOptions);
    }

    GetLHContractList(intype: number, ilocid: number, userid: number): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.get(environment.WebserviceUrl + "Lorryhirecontract?intype=" + intype + "&ilocid=" + ilocid + "&userid=" + userid, httpOptions);
    }

    GetTruckArrivalDetail(input: string): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.get(environment.WebserviceUrl + "Lorryhirecontract/" + input, httpOptions);
    }

    GETTRUCKARRIVALDETAILCHALLANLIST(intype: number, arrivalno: string): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.get(environment.WebserviceUrl + "LHContractHelper?intype=" + intype + "&arrivalno=" + arrivalno, httpOptions);
    }


    //===============================GPSDATA============================================================================
    GETGPSDATA(intype: number, vhno: string): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.get(environment.WebserviceUrl + "GPSData?intype=" + intype + "&vhno=" + vhno , httpOptions);
    }

    SearchChallan(intype:number, searchby: number, searchvalue: string,floc:number,tloc:number,fromdate:string,enddate:string,userid:number): Observable<any> {
        let headers = new HttpHeaders();
 headers = headers.append("Authorization", "Bearer " + environment.token);
        headers = headers.append("Content-Type", "application/json");
        const httpOptions = { headers };
        return this._httpClient.get(environment.WebserviceUrl + "vchalan?intype=" + intype + "&searchby=" + searchby + "&searchbyvalue=" + searchvalue
            + "&floc=" + floc + "&tloc=" + tloc + "&fromdate=" + fromdate + "&enddate=" + enddate + "&userid=" + userid, httpOptions);
    }
}
